// Central UI helpers for activity + inscription statuses.
// Labels are i18n keys — resolve via useLang().t(labelKey).
export const ACTIVITY_STATUS = {
  disponible: { labelKey: "status.disponible", bg: "hsl(var(--primary))", fg: "#FFF8ED" },
  inscriptions_ouvertes: { labelKey: "status.inscriptions_ouvertes", bg: "hsl(var(--primary))", fg: "#FFF8ED" },
  complet: { labelKey: "status.complet", bg: "#8B1E1E", fg: "#FFF8ED" },
  liste_attente: { labelKey: "status.liste_attente", bg: "hsl(var(--coral))", fg: "#FFF8ED" },
  bientot: { labelKey: "status.bientot", bg: "hsl(var(--plum))", fg: "#FFF8ED" },
  projet_futur: { labelKey: "status.projet_futur", bg: "#6B7280", fg: "#FFF8ED" },
};

// Inscription statuses stay FR-only labels — admin UI is FR-only.
export const INSCRIPTION_STATUS = {
  nouveau: { label: "Nouveau", bg: "hsl(var(--accent))", fg: "hsl(var(--foreground))" },
  a_rappeler: { label: "À rappeler", bg: "hsl(var(--coral))", fg: "#FFF8ED" },
  confirme: { label: "Confirmé", bg: "hsl(var(--primary))", fg: "#FFF8ED" },
  liste_attente: { label: "Liste d'attente", bg: "hsl(var(--plum))", fg: "#FFF8ED" },
  oriente: { label: "Orienté", bg: "#6B7280", fg: "#FFF8ED" },
  cloture: { label: "Clôturé", bg: "#3F3F46", fg: "#FFF8ED" },
};

export const ACTIVITY_STATUS_ORDER = [
  "disponible",
  "inscriptions_ouvertes",
  "liste_attente",
  "complet",
  "bientot",
  "projet_futur",
];

export const INSCRIPTION_STATUS_ORDER = [
  "nouveau",
  "a_rappeler",
  "confirme",
  "liste_attente",
  "oriente",
  "cloture",
];

export function canRegister(status) {
  return status === "disponible" || status === "inscriptions_ouvertes" || status === "liste_attente";
}
